import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISpUser } from 'Models/ResponseModels/authentication'

export interface ILifeQuotationStoreValues {
  // selectedFilterData?: Record<string, string | number | boolean | string[]>
  // planQuoteId?: string
  // biPdfUrl?: string
  selectedSp?: ISpUser
}

const initialState: ILifeQuotationStoreValues = {}

const lifeQuotationSlice = createSlice({
  name: 'lifeQuotationSlice',
  initialState: initialState,
  reducers: {
    // updateSelectedFilterData: (
    //   state,
    //   action: PayloadAction<Record<string, string | number | boolean | string[]>>,
    // ) => {
    //   state.selectedFilterData = action.payload
    // },
    // updatePlanQuoteId: (state, action: PayloadAction<string>) => {
    //   state.planQuoteId = action.payload
    // },
    // updateBiPdfUrl: (state, action: PayloadAction<string>) => {
    //   state.biPdfUrl = action.payload
    // },
    updateSelectedSp: (state, action: PayloadAction<ISpUser>) => {
      state.selectedSp = action.payload
    },
    updateAllLifeQuotationData: (state, action: PayloadAction<ILifeQuotationStoreValues>) => {
      const { selectedSp } = action.payload
      if (selectedSp !== undefined) {
        state.selectedSp = selectedSp
      }
    },
    resetAllLifeQuotationData: () => initialState,
  },
})

const { reducer } = lifeQuotationSlice

const {
  //  updateSelectedFilterData, updatePlanQuoteId, updateBiPdfUrl
  updateSelectedSp,
  updateAllLifeQuotationData,
  resetAllLifeQuotationData,
} = lifeQuotationSlice.actions

export {
  reducer as lifeQuotationReducer,
  // updateSelectedFilterData,
  // updatePlanQuoteId,
  // updateBiPdfUrl,
  updateSelectedSp,
  updateAllLifeQuotationData,
  resetAllLifeQuotationData,
}
